import { render, staticRenderFns } from "./ClinicBranchMultiSelect.vue?vue&type=template&id=60e651e8"
import script from "./ClinicBranchMultiSelect.vue?vue&type=script&lang=js"
export * from "./ClinicBranchMultiSelect.vue?vue&type=script&lang=js"
import style0 from "./ClinicBranchMultiSelect.vue?vue&type=style&index=0&id=60e651e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports